
import * as THREE from 'three';
export default class FramedWallPicture {
    constructor(imagePath){
        let dimPicture = new THREE.Vector2(2,2); // width, height of picture
        let dimFrameBorder = new THREE.Vector2(.05, .05); // border width, depth
        let dimFrame = new THREE.Vector2(3,3); // width, height of frame
        let pictureInset = dimFrameBorder.y * .5;
        let group = new THREE.Group();
        var texture = new THREE.TextureLoader().load( imagePath );
        
        // card stock
        var geoCard = new THREE.PlaneGeometry( dimFrame.x, dimFrame.y );
        var matCard = new THREE.MeshBasicMaterial( {
            color: 0xffffff,  
            side: THREE.DoubleSide
        });
        let meshCard = new THREE.Mesh( geoCard, matCard );
        meshCard.position.z = dimFrameBorder.y-pictureInset - .01;

        var geoPic = new THREE.PlaneGeometry( dimPicture.x, dimPicture.y );
        var matPic = new THREE.MeshBasicMaterial( {
            color: 0xffffff,  
            map: texture,
            side: THREE.DoubleSide
        });
        let meshPic = new THREE.Mesh( geoPic, matPic );
        meshPic.position.z = dimFrameBorder.y-pictureInset;

        var matFrame = new THREE.MeshBasicMaterial( {color: 0x000000});

        var geoLeft = new THREE.BoxBufferGeometry( dimFrameBorder.x , dimFrame.y + (1*dimFrameBorder.x), dimFrameBorder.y );
        let meshFrameLeft = new THREE.Mesh( geoLeft, matFrame );
        meshFrameLeft.position.x = -dimFrame.x/2;
        meshFrameLeft.position.z = dimFrameBorder.y;

        var geoRight = new THREE.BoxBufferGeometry( dimFrameBorder.x , dimFrame.y + (1*dimFrameBorder.x), dimFrameBorder.y);
        let meshFrameRight = new THREE.Mesh( geoRight, matFrame );
        meshFrameRight.position.x = dimFrame.x/2;
        meshFrameRight.position.z = dimFrameBorder.y;

        var geoTop = new THREE.BoxBufferGeometry( dimFrame.x + (1*dimFrameBorder.x), dimFrameBorder.x, dimFrameBorder.y );
        let meshFrameTop = new THREE.Mesh( geoTop, matFrame );
        meshFrameTop.position.y = dimFrame.y/2;
        meshFrameTop.position.z = dimFrameBorder.y;

        var geoBot = new THREE.BoxBufferGeometry( dimFrame.x + (1*dimFrameBorder.x), dimFrameBorder.x, dimFrameBorder.y );
        let meshFrameBot = new THREE.Mesh( geoBot, matFrame );
        meshFrameBot.position.y = -dimFrame.y/2;
        meshFrameBot.position.z = dimFrameBorder.y;
        
        
        group.add(meshCard);
        group.add(meshFrameLeft);
        group.add(meshFrameRight);
        group.add(meshFrameTop);
        group.add(meshFrameBot);
        group.add(meshPic);
        return group;
    }


}